module.exports = __webpack_public_path__ + "facebook.svg?232a77ec7f996e286fe76925d66b6b6f";